/**
 * SearchMessage component.
 */
import Colors from '@shared/assets/style/default/color';
import Fonts from '@shared/assets/style/default/fonts';
import Screen from '@shared/utils/screen';
import styled from 'styled-components';

/**
 * Styled search message.
 */
const SearchMessage = styled.span<{ searching?: boolean }>`
  color: ${Colors.modal['title']};
  display: flex;
  font-family: ${Fonts['regular']};
  font-size: ${24 * Screen.widthRatio}px;
  left: ${(props) => (props.searching ? 980 : 373) * Screen.widthRatio}px;
  position: absolute;
  top: ${55 * Screen.widthRatio}px;
  width: ${1358 * Screen.widthRatio}px;
`;

export default SearchMessage;
